import React, { Component } from 'react';
import { loadModules } from 'esri-loader';
import Data from '../../utils/data';
import API from '../../utils/api';
import moment from 'moment';

class MapLayer extends Component {
    constructor(props) {
        super(props)
        this.state = {
            forecast: null,
            lastUpdated: null
        }
    }

    // component should only ever render once, and then not update.  
    // all map actions should come via prop changes
    // that trigger esri/arcgis methods inside componentWillReceiveProps
   shouldComponentUpdate() {
        return false;
    };

    // show items on the map w/ the symbol and popupTemplate from the config
    componentWillReceiveProps(nextProps) {

        // if props.center changes, use esrii goTo method to recenter/move to the new lat/long 
        if (nextProps.center !== this.props.center) {
            this._view.goTo({ center: nextProps.center, zoom: nextProps.zoom });
        }

        // if buildingMarker changes, add or remove building point as appropriate
        if (nextProps.buildingMarker !== this.props.buildingMarker) {

            this._buildingMarkerUpdate(nextProps.buildingMarker);
        }

        // if noaaGageID changes, update the forecast slider and get forecast data for that gage ID
        if ((nextProps.noaaGageID !== this.props.noaaGageID || (nextProps.refreshData !== this.props.refreshData))) {
            // ******* Don't think we have to go get the forecast data again on the Forecast section click since we already get it on the gage click... *******
            this.setForecastData(nextProps.noaaGageID, nextProps.currentStage);
        }

        // if dashboard view changes or user clicks refresh data, and there is a valid gage selected, get elevation and toggle rasters
        if (((nextProps.dashboardView !== this.props.dashboardView) || (nextProps.refreshData !== this.props.refreshData)) && (this.props.usgsGageID !== null || nextProps.usgsGageID !== null)) {
            // Turn off the building popup when switching views
            if (this._view.popup.visible != null) {
                this._view.popup.visible = false;
            }

            if (nextProps.dashboardView === "forecast") {
                // Need to properly capture the slider value on initial view
                const Elev = Math.round(nextProps.forecastSliderValue);
                this._rasterToggle(Elev, "forecast")
                    .then(() => {
                        this._setForecastCondition(Elev);
                    });

            } else if (nextProps.dashboardView === "current" && (this.props.usgsGageID === nextProps.usgsGageID)) {
                this._rasterToggle(nextProps.currentElevation, nextProps.dashboardView)
                    .then(() => {
                        if (nextProps.center) {
                            this._view.goTo({ center: nextProps.center, zoom: nextProps.zoom });
                        }
                    });

            } else if (nextProps.dashboardView === "scenario") {
                // Need to properly capture the slider value on initial view
                this._rasterToggle(nextProps.scenarioSliderValue, "scenario")
                    .then(() => {
                        this._setScenarioCondition(nextProps.scenarioSliderValue);
                    }); 
            }
        }
    };

    // if usgsID changes or user refreshes data, get forecast from API and update forecast Slider
    // make forecast object available to map for forecast slider value lookup

    forecast = {};    

    getForecastValues() {
        return this.forecast;
    };

    // ******* Don't think we have to go get the forecast data again on the Forecast section click since we already get it on the gage click... *******
    setForecastData = (noaaGageID, currentStage) => {
        if (noaaGageID !== null) {

            let now = moment();

            let timeObjs = [now];
            let stageTicks = [currentStage.toFixed(1)];
            let tickPositions = [0];

            // not using peak info yet - may want to style peak value differently
            // on label render.  Remove code if this isn't going to be required.
            let peakObj = {
                dataValue: null,
            };
            let peakStage = 0;

            API.getNOAAForecast(noaaGageID, '00065').then(response => response.json())
                .then(data => {
                    if (data) {
                        //now = data[0].lastUpdated; // temporary with Michael Data...

                        this.forecast["0"] = { "stage": currentStage, "dateReading": now };

                        for (let i = 0; i < data.length; i++) {
                            stageTicks.push((data[i].dataValue).toFixed(1));
                            tickPositions.push(tickPositions[i] + 6);
                            timeObjs.push(moment(data[i].dateReading));

                            this.forecast[tickPositions[i + 1]] = { "stage": stageTicks[i + 1], "dateReading": data[i].dateReading }

                            if (data[i].dataValue > peakObj.dataValue) {
                                peakObj = data[i];
                            }
                        }

                        peakStage = peakObj.dataValue.toFixed(1);

                        let forecastData = {
                            stageTicks: stageTicks,
                            timeObjs: timeObjs,
                            tickPositions: tickPositions,
                            peakStage: peakStage
                        }

                        this.updateForecastSlider(forecastData);

                    } else {
                        console.log("no data")
                    }
                })
                .catch(err => {
                    console.log(err);
                    });
        }

    };

    // update and format the esri slider 
    updateForecastSlider = (forecastData) => {
        this._forecastSlider.min = 0;
        this._forecastSlider.max = forecastData.tickPositions[forecastData.tickPositions.length - 1];
        this._forecastSlider.steps = forecastData.tickPositions;
        this._forecastSlider.values = [0];


        // Need to include 0 as a tick value so that the slider can display current conditions
        // Also as the slider is created, need to trigger the first tick to display info and layers correctly
        // This needs to be applied to the Scenario slider as well

        this._forecastSlider.tickConfigs = [{
            mode: 'position',
            values: forecastData.tickPositions,
            labelsVisible: true,
            tickCreatedFunction: function (initialValue, tickElement, labelElement) {
                let valueIndex = forecastData.tickPositions.indexOf(initialValue);
                if (forecastData.stageTicks[valueIndex] === forecastData.peakStage) {
                    labelElement.classList.add("peakDateLabels");
                } else {
                    labelElement.classList.add("dateLabels");
                }
                tickElement.classList.add("dateTicks");
            },
            labelFormatFunction: function (value, type, index) {
                let label = '';
                if (index === 0) {
                    label = null;
                } else if (moment(forecastData.timeObjs[index]).isAfter(forecastData.timeObjs[index - 1], 'day')) {
                    label = moment(forecastData.timeObjs[index]).format('M/D');
                }
                return label;
            }
        }, {
            mode: 'position',
            values: forecastData.tickPositions,
            labelsVisible: true,
            tickCreatedFunction: function (initialValue, tickElement, labelElement) {
                let valueIndex = forecastData.tickPositions.indexOf(initialValue);
                if (forecastData.stageTicks[valueIndex] === forecastData.peakStage) {
                    labelElement.classList.add("peakLabels");

                } else {
                    labelElement.classList.add("timeLabels");

                }
                tickElement.classList.add("timeTicks");
            },
            labelFormatFunction: function (value, type, index) {
                return index === 0 ? "NOW" : moment(forecastData.timeObjs[index]).format('h A');
            }
        }, {
            mode: 'position',
            values: forecastData.tickPositions,
            labelsVisible: true,
            tickCreatedFunction: function (initialValue, tickElement, labelElement) {
                let valueIndex = forecastData.tickPositions.indexOf(initialValue);
                if (forecastData.stageTicks[valueIndex] === forecastData.peakStage) {
                    labelElement.classList.add("stagePeakLabels");

                } else {
                    labelElement.classList.add("stageLabels");

                }
                tickElement.classList.add("stageTicks");
            },
            labelFormatFunction: function (value, type, index) {
                return forecastData.stageTicks[index];
            }

        }];

        this._forecastSlider.viewModel.snapOnClickEnabled = true;
    };


    // reset gage, map center/zoom, and dashboard view info on home widget click
    homeWidget = (e) => {
        this.props.setGageName(null);
        this.props.setUSGSGageID(null);
        this.props.setNOAAGageID(null);
        this.props.setCenterAndZoom([-79.9414, 37.2710], 13);
        this.props.setBuildingMarker(null);
        this.props.setDashboardAndSlider(null);
        if (document.getElementById("sliderScenarioDiv")) {
            document.getElementById("sliderScenarioDiv").style.display = "none";
        }

    };

    // function to init/load map.  This is called when component mounts
    // map is only ever rendered once
    loadMap(props, forecastValues) {
        return loadModules(['esri/Map', 'esri/views/MapView', 'esri/Basemap', 'esri/widgets/BasemapGallery', "esri/widgets/BasemapToggle", 'esri/widgets/Search', 'esri/widgets/Home', 'esri/widgets/Expand', 'esri/layers/TileLayer', 'esri/layers/FeatureLayer', 'esri/widgets/Slider', "esri/widgets/Legend", "esri/widgets/DistanceMeasurement2D", "esri/layers/ImageryLayer", "esri/layers/support/RasterFunction", "esri/widgets/Measurement", "esri/widgets/Zoom", "esri/Graphic", "esri/layers/GraphicsLayer"])
            .then(([Map, MapView, Basemap, BasemapGallery, BasemapToggle, Search, Home, Expand, TileLayer, FeatureLayer, Slider, Legend, DistanceMeasurement2D, ImageryLayer, RasterFunction, Measurement, Zoom, Graphic, GraphicsLayer]) => {
                //create renderer for the feature class
                const topomap = new TileLayer({
                    url: Data.mapUrl,
                    maxScale: 36112
                });

                const imagery = new TileLayer({
                    url: Data.imageryUrl,
                    minScale: 36112
                });


                const defaultBasemap = new Basemap({
                    baseLayers: [topomap, imagery],
                    title: "Roanoke Basemap and Imagery",
                    id: "roanokeBasemap"
                });

                const map = new Map({
                    basemap: defaultBasemap
                });

                 // other opt to rendre the feature layer
                //const renderer = {
                //    type: "unique-value",
                //    field: "CONDITION_TXT",
                //    field2: "TREND",
                //    field3: "FORECAST_CONDITION",
                //    fieldDelimiter: ", ",
                //    defaultSymbol: { type: "picture-marker" },
                //    uniqueValueInfos: Data.symbolesValues
                //}

                // load the map view at the ref's DOM node
                const view = new MapView({
                    container: "viewDiv",
                    map: map,
                    center: [-79.9414, 37.2710], //currentCeneter
                    zoom: 13 //currentZoom
                });


                // these values for building the slider will need to be pulled from the DB or hardcoded...
                // Set based on what is returned from the gage info on it scenario min and max levels
                // ELEVATION - DATUM = Stage value for each tick...

                const scenarioStageValues = [7.6, 9.6, 11.6, 13.6, 15.6, 17.6, 19.6, 21.6, 23.6, 25.6, 27.6];
 
                const sliderScenario = new Slider({
                    min: 913, // Scenario Min
                    max: 935, // Scenario Max
                    values: [913.0], // Current Elevation or Scenario Min
                    steps: 1,
                    snapOnClickEnabled: true,
                    labelsVisible: false,
                    rangeLabelsVisible: true,
                    tickConfigs: [{
                        mode: 'position',
                        values: [914, 916, 918, 920, 922, 924, 926, 928, 930, 932, 934],
                        labelsVisible: true,
                        tickCreatedFunction: function (initialValue, tickElement, labelElement) {
                            tickElement.classList.add("scenarioTicks");
                            labelElement.classList.add("scenarioLabels");
                        }
                    }, {
                        mode: 'position',
                        values: [914, 916, 918, 920, 922, 924, 926, 928, 930, 932, 934],
                        labelsVisible: true,
                        tickCreatedFunction: function (initialValue, tickElement, labelElement) {
                            tickElement.classList.add("scenarioStageTicks");
                            labelElement.classList.add("scenarioStageLabels");
                        },
                        labelFormatFunction: function (value, type, index) {
                            return scenarioStageValues[index];
                        }
                    }]
                });

                sliderScenario.container = "sliderScenarioDiv";
                view.ui.add(sliderScenario);

                sliderScenario.on("thumb-drag", function (e) {

                    const sliderValue = sliderScenario.values[0];
                    const Elev = Number(sliderValue);

                    if (view.popup.visible != null) {
                        view.popup.visible = false;
                    }

                    rasterToggle(Elev, "scenario")
                    setScenarioCondition(Elev);
                    props.setScenarioSliderValue(Elev);
                                    

                });

                // **** New test slider for forecast ****
                const sliderForecast = new Slider({
                    values: [0], // Forecast Min
                    snapOnClickEnabled: true,
                    labelsVisible: false,
                    rangeLabelsVisible: false,
                });

                sliderForecast.container = "sliderForecastDiv";
                view.ui.add(sliderForecast);


                sliderForecast.on("thumb-drag", function (e) {

                    const sliderValue = sliderForecast.values[0];
                    const Hours = Number(sliderValue);
                    const Stage = Number(forecastValues[Hours].stage);
                    const DateReading = forecastValues[Hours].dateReading;
                    const Elev = Math.round(Stage + 906.4);

                    if (view.popup.visible != null) {
                        view.popup.visible = false;
                    }
                   
                    props.setForecastSliderValue(Elev);
                    props.setForecastStageValueAndDateReading(Stage, DateReading);
                    rasterToggle(Elev, "forecast");


                    // **** UPDATE TO POINT TO FORECAST VALUES ****
                    setForecastCondition(Elev);

                });
          
                // raster colorize function
                function colorizeRaster(pixelData) {
                  
                    if (
                        pixelData === null ||
                        pixelData.pixelBlock === null ||
                        pixelData.pixelBlock.pixels === null
                    ) {
                        return;
                    }

                    // The pixelBlock stores the values of all pixels visible in the view
                    const pixelBlock = pixelData.pixelBlock;

                    // Get the min and max values of the data in the current view
                    const minValue = pixelBlock.statistics[0].minValue;
                    const maxValue = pixelBlock.statistics[0].maxValue;
                    const pixels = pixelBlock.pixels;
               
                    // The number of pixels in the pixelBlock
                    const numPixels = pixelBlock.width * pixelBlock.height;
                                   
                    const factor = 255.0 / (maxValue - minValue);
                    
                    const depthBand = pixels[0];
                    let rBand = [];
                    let gBand = [];
                    let bBand = [];

                    for (let i = 0; i < numPixels; i++) {
                        let depthValue = depthBand[i];
                        let green = (maxValue - depthValue)* factor ;
                        rBand[i] = green * 0.75;
                        gBand[i] = green;
                        bBand[i] = 255;
                    }

                    pixelData.pixelBlock.pixels = [rBand, gBand, bBand];
                    pixelData.pixelBlock.pixelType = "U8"; // U8 is used for color
                }
               


                // Need to rethink how we are setting up each of the rasters and try to mimic a style we used for SERA DAMS
                // Prevent having to lead each layer everytime we toggle the slider
                // All layers should be loaded in as once, and then toggled on and off as sublayers
                const inundationRasters = new ImageryLayer({
                    pixelFilter: colorizeRaster,
                    opacity: 0.5,
                    minScale: 36112,
                    id: "inundationRaster",
                  
                    //renderingRule: colorRaster,
                });

                const buildingLayer = new FeatureLayer({
                    url: Data.buildingsURL,                   
                    visible: false,
                    definitionExpression: "Library = 913",
                    outFields: ["*"],
                    minScale: 36112,
                    id: "buildingLayer"
                });
                map.add(buildingLayer);

                var buildingCritLayer = new FeatureLayer({
                    url: Data.buildingsCritURL,
                    visible: false,
                    definitionExpression: "Library = 913",
                    outFields: ["*"],
                    id: "buildingLayer"
                });

                map.add(buildingCritLayer);

                const buildingMarkerLayer = new GraphicsLayer({
                    visible: false,
                });
                map.add(buildingMarkerLayer);

                // create Layer for all gages with trend icons
                const gageForecast = new FeatureLayer({
                    url: Data.gageForecastURL,
                    outFields: ["*"],
                    visible: true,
                    id: "gageForecastLayer"
                });
                map.add(gageForecast);

                const gageLayer = new FeatureLayer({
                    url: Data.gageURL,
                    mode: FeatureLayer.MODE_SNAPSHOT,
                    outFields: ["*"],
                    opacity: 1.0,
                    supportsPagination: true,
                    refreshInterval: 15,
                    id: "gageLayer"
                });
                map.add(gageLayer);

                const gageTrend = new FeatureLayer({
                    url: Data.gageTrendURL,
                    outFields: ["*"],
                    visible: true,
                    id: "gageTrendLayer"
                });
                map.add(gageTrend);
                

                const search = new Search({
                    view: view,
                    container: document.createElement("div")
                });

                const bgExpand = new Expand({
                    view: view,
                    content: search,
                });
                view.ui.add(bgExpand, "top-left");

                view.ui.move("zoom", "top-left");

                //home customized to close all opend modals and set the zoom level to the intial value
                const homeBtn = new Home({
                    viewModel: {
                        view: view
                    },

                }, "homeWidget");
                view.ui.add(homeBtn, "top-left");

                homeBtn.viewModel.on("go", function (e) {
                    inundationRasters.visible = false;
                    buildingLayer.visible = false;
                    buildingCritLayer.visible = false
                    sliderScenario.values = [913];
                    document.getElementById("scenarioCondition").innerHTML = "";
                    
                });
                // Create an Expand instance and set the content
                // property to the DOM node of the basemap gallery widget

                var basemapGallery = new BasemapGallery({
                    view: view
                });
                var expandBmap = new Expand({
                    expandIconClass: "esri-icon-basemap",
                    view: view,
                    content: basemapGallery,
                });
                view.ui.add(expandBmap, "top-left");

                var legend = new Legend({
                    view: view,
                    layerInfos: [
                        {
                            layer: gageLayer,
                            title: "Gage Condition"
                        },
                        {
                            layer: gageTrend,
                            title: "Gage Trend"
                        },
                        {
                            layer: buildingCritLayer,
                            title: "Potential Critical Buildings"
                        },
                        {
                            layer: buildingLayer,
                            title: "Potential Impacted Buildings"
                        }
                    ]
                });

                //view.ui.add(legend, "bottom-right");

                const expand = new Expand({
                    expandIconClass: "esri-icon-layer-list",
                    view: view,
                    content: legend
                });
                view.ui.add(expand, "top-left");

                const zoom = new Zoom({
                    view: view
                });
                // Removing references to the measurement tool...
                //const measurementWidget = new DistanceMeasurement2D({
                //    view: view
                //});

                //const measurement = new Measurement({
                //    view : view
                //});

                //view.ui.add(measurement, "bottom-left");

                //const measurementExpand = new Expand({
                //    expandIconClass: "esri-icon-measure-line",
                //    view: view,
                //    content: measurement
                //});
                //view.ui.add(measurementExpand, "top-left");
                //const distanceButton = document.getElementById("distanceMesurment");
                //const clearButton = document.getElementById("clearWidget");

                //distanceButton.addEventListener("click", function (e) {
                //    measurement.view = view,
                //        measurement.activeTool = "distance"
                //});

                //clearButton.addEventListener("click", function (e) {
                //    measurement.clear();
                //});

                // raster inundation layer toggle
               
                const rasterToggle = async (value, dbView) => {
                    if (Data.rasterLevelsArray.includes(value)) {
                        await map.remove(inundationRasters)
                        inundationRasters.url = await `${Data.inundationRasterURL}rDpth${value}/ImageServer`;
                        await map.add(inundationRasters, 0);
                        inundationRasters.visible = true;
                        buildingLayer.definitionExpression = `Library = ${value}`;
                        buildingCritLayer.definitionExpression = `Library = ${value}`;
                        buildingLayer.visible = true;
                        buildingCritLayer.visible = true;
                        //if (dbView !== "current") { // This only needs to be called once and not on every tick change...
                        //    this._view.goTo({ zoom: 16 });
                        //}
                        if (view.zoom) {
                            const newZoom = view.zoom
                            if (dbView !== "current") {
                                    view.zoom = newZoom + 0.001
                            }
                        } 
                        
                    } else {
                        inundationRasters.visible = false;
                        buildingLayer.visible = false;
                        buildingCritLayer.visible = false;
                    }

                }

                // function to add/remove building marker on impacted buildings click
                const buildingMarkerUpdate = (buildingCoordinates) => {

                    buildingMarkerLayer.removeAll();

                    if (buildingCoordinates === null) {
                        buildingMarkerLayer.visible = false;
                    } else {
                        // building marker graphics
                        var point = {
                            type: "point", // autocasts as new Point()
                            longitude: buildingCoordinates[0],
                            latitude: buildingCoordinates[1]
                        };

                        // Create point symbol
                        var markerSymbol = {
                            type: "simple-marker", 
                            color: [226, 119, 40],
                            outline: {
                                color: [255, 255, 255],
                                width: 2
                            }
                        };

                        // Create a graphic and add the geometry and symbol to it
                        var buildingMarkerGraphic = new Graphic({
                            geometry: point,
                            symbol: markerSymbol
                        });

                        buildingMarkerLayer.add(buildingMarkerGraphic);
                        buildingMarkerLayer.visible = true;
                    }

                }



                const setScenarioCondition = (sliderValue) => {
                    if (sliderValue >= 912 && sliderValue < 916) {
                        document.getElementById("scenarioCondition").innerHTML = "Action";
                        document.getElementById("scenarioCondition").style.backgroundColor = "rgb(255, 204, 0)"; // yellow
                        document.getElementById("scenarioCondition").style.color = "black";


                    } else if (sliderValue >= 916 && sliderValue < 918) {
                        document.getElementById("scenarioCondition").innerHTML = "Minor Flooding";
                        document.getElementById("scenarioCondition").style.backgroundColor = "rgb(255, 135, 0)"; // orange
                        document.getElementById("scenarioCondition").style.color = "black";

                    } else if (sliderValue >= 918 && sliderValue < 922) {
                        document.getElementById("scenarioCondition").innerHTML = "Moderate Flooding";
                        document.getElementById("scenarioCondition").style.backgroundColor = "rgb(255, 0, 0)"; // red
                        document.getElementById("scenarioCondition").style.color = "white";

                    } else if (sliderValue >= 922) { // && sliderValue <= 935
                        document.getElementById("scenarioCondition").innerHTML = "Major Flooding";
                        document.getElementById("scenarioCondition").style.backgroundColor = "rgb(153, 0, 255)"; // purple
                        document.getElementById("scenarioCondition").style.color = "white";

                    } else if (sliderValue < 912) { // && sliderValue <= 935
                        document.getElementById("scenarioCondition").innerHTML = "Normal Conditions";
                        document.getElementById("scenarioCondition").style.backgroundColor = "rgb(0, 204, 51)"; // green
                        document.getElementById("scenarioCondition").style.color = "black";

                    }
                }

                const setForecastCondition = (sliderValue) => {
                    if (sliderValue >= 912 && sliderValue < 916) {
                        document.getElementById("forecastCondition").innerHTML = "Action";
                        document.getElementById("forecastCondition").style.backgroundColor = "rgb(255, 204, 0)"; // yellow
                        document.getElementById("forecastCondition").style.color = "black";

                    } else if (sliderValue >= 916 && sliderValue < 918) {
                        document.getElementById("forecastCondition").innerHTML = "Minor Flooding";
                        document.getElementById("forecastCondition").style.backgroundColor = "rgb(255, 135, 0)"; // orange
                        document.getElementById("forecastCondition").style.color = "black";


                    } else if (sliderValue >= 918 && sliderValue < 922) {
                        document.getElementById("forecastCondition").innerHTML = "Moderate Flooding";
                        document.getElementById("forecastCondition").style.backgroundColor = "rgb(255, 0, 0)"; // red
                        document.getElementById("forecastCondition").style.color = "white";


                    } else if (sliderValue >= 922) { // && sliderValue <= 935
                        document.getElementById("forecastCondition").innerHTML = "Major Flooding";
                        document.getElementById("forecastCondition").style.backgroundColor = "rgb(153, 0, 255)"; // purple
                        document.getElementById("forecastCondition").style.color = "white";

                    } else if (sliderValue < 912) { // && sliderValue <= 935
                        document.getElementById("forecastCondition").innerHTML = "Normal Conditions";
                        document.getElementById("forecastCondition").style.backgroundColor = "rgb(0, 204, 51)"; // green
                        document.getElementById("forecastCondition").style.color = "black";

                    }
                }
                
                // return components of map that need to respond to user interaction
                let mapReturn = {
                    map: map,
                    inundationRasters: inundationRasters,
                    rasterToggle: rasterToggle,
                    buildingMarkerUpdate: buildingMarkerUpdate,
                    mapView: view,
                    mapBuildingLayer: buildingLayer,
                    mapBuildingCritLayer: buildingCritLayer,
                    mapSlider: sliderScenario,
                    forecastSlider: sliderForecast,
                    setScenarioCondition: setScenarioCondition,
                    setForecastCondition: setForecastCondition
                }
                return mapReturn;

            })
    }


    // when component mounts, load map, map return values available to class methods
    // and add click watcher
    componentDidMount() {





        const forecastValues = this.getForecastValues();
        //call load map, which returns map components we need to modified on user interaction
        this.loadMap(this.props, forecastValues).then(mapReturn => {
            //assign view, inundationLayer to global so available for update outside of componentDidMount
            this._map = mapReturn.map;
            this._inundationRasters = mapReturn.inundationRasters;
            this._view = mapReturn.mapView;
            this._inundationLayer = mapReturn.mapInundationLayer;
            this._buildingLayer = mapReturn.mapBuildingLayer;
            this._buildingCritLayer = mapReturn.mapBuildingCritLayer;
            this._forecastSlider = mapReturn.forecastSlider;
            this._rasterToggle = mapReturn.rasterToggle;
            this._buildingMarkerUpdate = mapReturn.buildingMarkerUpdate;
            this._setScenarioCondition = mapReturn.setScenarioCondition;
            this._setForecastCondition = mapReturn.setForecastCondition;

            // local instances of view, slider, inundationLayer and buildingLayer to updated when props change
            // and users interact with map and dashboard
            let view = mapReturn.mapView;
            let inundationRasters = mapReturn.inundationRasters;
            let inundationLayer = mapReturn.mapInundationLayer;
            let buildingLayer = mapReturn.mapBuildingLayer;
            let buildingCritLayer = mapReturn.mapBuildingCritLayer;
            let slider = mapReturn.mapSlider;

            slider.trackElement.classList.add("scenarioTrack");

            view.popup.dockOptions = {
                 buttonEnabled: false
            };

            view.popup.collapseEnabled = false;

            view.on("click", function (evt) {
                const screenPoint = evt.screenPoint;
                // esri hitTest() methodchecks to see if any graphics in the view
                // intersect the given screen point
                view.hitTest(screenPoint)
                    .then(getLayerInfo)

                //toggleDrawer(true);
            });

            //view.on("pointer-move", function (evt) {
            //    view.hitTest(evt).then(getGageInfo)
            //});


            //var strWindowFeatures = "location=yes,scrollbars=yes,status=yes";

            // Neeed to update/implement logic on the click of the inundarion raster and how that can conflict with the building/gage layer
            // Should only have one template on the click and not 2 or 3
            // Click on Building = Building Info only
            // click in Raster = Raster Info only
            const getLayerInfo = (response) => {

                // Need to check which layer the click event is captured on to call the specific funcitons associated with them...
                //console.log(response)
                // the topmost graphic from the click location
                // and display select attribute values from the
                // layer to the user
                const attributes = response.results[0].graphic.attributes;
                inundationRasters.popupEnabled = false;
                // Change to a switch statement when more layers are fucntional and added
                // Need a propper way to determine the layer
                // Shouldn't conduct a click on the view but on the layer instead to capture correct attributes
                if (attributes.USGS_SITE_ID) {
                    // Gage Layer
                    switch (attributes.USGS_SITE_ID) {
                        case "02054750":
                            window.open("https://waterdata.usgs.gov/va/nwis/uv?site_no=02054750", "_blank"); // strWindowFeatures
                            inundationLayer.visible = false;
                            buildingLayer.visible = false;
                            //alert("Data Not Available");
                            document.getElementById("sliderScenarioDiv").style.display = "none";
                            document.getElementById("sliderForecastDiv").style.display = "none";
                            break;
                        case "02055000":
                            // set the gageIDs, gageDatum, map center/zoom, and gageName state to attributes of selected gage                        
                            this.setState({ lastUpdated: moment(attributes.OBSERVED_LAST_UPDATED, "MMM D YYYY h:mA") });
                            this.props.setUSGSGageID(attributes.USGS_SITE_ID);
                            this.props.setCenterAndZoom([attributes.LONGITUDE, attributes.LATITUDE], 16);
                            this.props.setGageName(attributes.NAME);
                            this.props.setGageDatum(attributes.GAGE_DATUM);
                            this.props.setCurrentStage(attributes.OBSERVED_STAGE);
                            var libraryLevel = Math.round(attributes.OBSERVED_ELEVATION);
                            this.props.setCurrentElevation(libraryLevel);


                            sessionStorage.setItem('firstVisit', '1');


                            if (attributes.NOAA_SITE_ID && attributes.NOAA_SITE_ID !== null) {
                                this.props.setNOAAGageID(attributes.NOAA_SITE_ID);
                            }

                            this.props.setDashboardAndSlider("current");

                            //// check if the elevation is within the library extent to show the layers or not and set up the definition expression only when needed...
                            if ((attributes.OBSERVED_ELEVATION > attributes.INUNDATION_SCENARIO_MIN_ELV) && (attributes.OBSERVED_ELEVATION < attributes.INUNDATION_SCENARIO_MAX_ELV)) {


                                // show buildings
                                buildingLayer.definitionExpression = "Library = " + libraryLevel; // round to the nearest inundation library
                                buildingLayer.visible = true;
                                slider.values = [libraryLevel];
                                //this.props.setScenarioSliderValue(libraryLevel);

                                // show critical buildings
                                buildingCritLayer.definitionExpression = "Library = " + libraryLevel; // round to the nearest inundation library
                                buildingCritLayer.visible = true;
                                //this.props.setBuildingLevelAndVisibility(buildingLayer, true);

                                //this.props.setInundationLevelAndVisibility(inundationLayer, true);
                            } else {
                                // hide buildings
                                buildingLayer.visible = false;
                                // hide inundation
                                inundationLayer.visible = false;
                                //slider.values = [attributes.INUNDATION_SCENARIO_MIN_ELV]; // Defaults to 913...
                                //this.props.setScenarioSliderValue(attributes.INUNDATION_SCENARIO_MIN_ELV);
                            }
                            break;
                        case "02055080":
                            window.open("https://waterdata.usgs.gov/va/nwis/uv?site_no=02055080", "_blank"); // strWindowFeatures
                            inundationLayer.visible = false;
                            buildingLayer.visible = false;
                            //alert("Data Not Available");
                            document.getElementById("sliderScenarioDiv").style.display = "none";
                            document.getElementById("sliderForecastDiv").style.display = "none"; 
                            break;
                        case "02056000":
                            window.open("https://waterdata.usgs.gov/va/nwis/uv?site_no=02056000", "_blank"); // strWindowFeatures
                            inundationLayer.visible = false;
                            buildingLayer.visible = false;
                            //alert("Data Not Available");
                            document.getElementById("sliderScenarioDiv").style.display = "none";
                            document.getElementById("sliderForecastDiv").style.display = "none";
                            break;
                        default:
                            break;
                    }

                } else if (attributes.BldgID) {
                    // Building Layer
                    //view.goTo({ center: [attributes.Longitude, attributes.Latitude] });
                    var Buildingtemplate;
                    // check if critical facility or normal building to display the name...
                    if (attributes.BldgName === "N/A") {
                        // Don't display Building Name
                        Buildingtemplate = {
                            title: 'Building Information',
                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [
                                        {
                                            fieldName: "Address",
                                            label: "Address"
                                        },
                                        {
                                            fieldName: "OccTypGen",
                                            label: "Type"
                                        },
                                        {
                                            fieldName: "Depth",
                                            label: "Depth (ft)"
                                        }
                                    ]
                                },
                                {
                                    type: "text",
                                    text: "<div class='depthDisclaimer'>Negative Depths = Substructure Flooding</div><a href='https://www.google.com/maps/@{Latitude},{Longitude},19z' target = `_blank` class='googleMaps'>To Google Maps</a>"
                                }
                            ]
                        };
                    } else {
                        // Display Building Name
                        Buildingtemplate = {
                            title: 'Building Information',
                            content: [
                                {
                                    type: "fields",
                                    fieldInfos: [
                                        {
                                            fieldName: "Address",
                                            label: "Address"
                                        },
                                        {
                                            fieldName: "OccTypGen",
                                            label: "Type"
                                        },
                                        {
                                            fieldName: "BldgName",
                                            label: "Name"
                                        },
                                        {
                                            fieldName: "Depth",
                                            label: "Depth (ft)"
                                        }
                                    ]
                                },
                                {
                                    type: "text",
                                    text: "<div class='depthDisclaimer'>Negative Depths = Substructure Flooding</div><a href='https://www.google.com/maps/@{Latitude},{Longitude},19z' target = `_blank` class='googleMaps'>To Google Maps</a>"
                                }
                            ]
                        };
                    }
                    buildingLayer.popupTemplate = Buildingtemplate;
                    buildingLayer.popup = {
                        dockEnabled: false,
                        collapseEnabled: false,
                        visible: true
                    }
                } else  { // Temporary...Need to come up with a better way to identify the raster layer
                    // Inundation Raster Layer
                    var InundationLayerTemplate = {
                        title: "Flood Depth (ft)",
                        content: "<div class='inundationPopup-depth'>{Raster.ServicePixelValue}</div>" // Need a way to filter out the other decimal places with .toFixed(1)
                    };
                   
                    inundationRasters.popupTemplate = InundationLayerTemplate;
                    inundationRasters.popupTemplate.overwriteActions = true;
                    inundationRasters.popupTemplate.actions = [];
                    inundationRasters.popupEnabled = true;
                }
            }

            // REMOVE IF NO LONGER NEEDED...
            // Hover Event for the features...
            // Update to display more information for each hover/click event
            // Place the popup over the mouse by captureing the x and y positioning of it            
            // 2 Differnt stylings...One for Bldgs...1 for Gages hover info...
            //const getGageInfo = (response) => {
            //    if (response.results.length >=1) {
            //        const attributes = response.results[0].graphic.attributes;
            //        window.onmousemove = function (e) {
            //            var mouseX = e.clientX;
            //            var mouseY = e.clientY;
            //            document.getElementById("featureInfo").style.left = (mouseX - 155) + "px"; 
            //            document.getElementById("featureInfo").style.top = (mouseY - 190) + "px"; 
            //        };
            //        if (attributes.USGS_SITE_ID) {
            //            const Name = attributes.NAME
            //            document.getElementById("featureInfo").style.display = "flex";
            //            document.getElementById("featureInfo").innerHTML = Name;

            //        } 
            //    } else {
            //        document.getElementById("featureInfo").style.display = "none";
            //    }

            //}

            return () => {
                if (view) {
                    // destroy the map view
                    view.container = null;
                }
            };


        });

        
    }
    // lazy load the required ArcGIS API for JavaScript modules and CSS

    // Removing references to the measurement tool...
    //<div id="distanceMesurment" className="esri-widget--button esri-interactive esri-icon-measure-line" />
    //<div id="clearWidget" className="esri-widget--button esri-icon-trash" />
    render() {

        return (
            <div className="mapLayer" >
                <div
                    className="full-screen-map"
                    style={{ width: '100vw', height: '100%' }}
                    id="viewDiv"
                />
                <div
                    id="homeWidget"
                    role="button"
                    tabIndex={0}
                    aria-label="Reset map to home view"
                    onClick={this.homeWidget}
                    onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); this.homeWidget(); } }}
                />
                {/*<div id="distanceMesurment" className="esri-widget--button esri-interactive esri-icon-measure-line" />
                <div id="clearWidget" className="esri-widget--button esri-icon-trash" />*/}
                <div id="featureInfo" />
                <div className="sliderDiv" id="sliderScenarioDiv" style={{ display: "none" }}>
                    <div className="sliderTitle">
                        <h6 id="mainTitle">Inundation Scenario*</h6>
                        <p>Scenario Stage/Elev (ft)</p>
                        <p id="scenarioCondition"></p>
                        <small id="scenarioText">* Elevation Based On Level At Walnut Ave. Gage</small>
                    </div>
                    <div className="sliderSubtitle">
                        <p id="stageSubtitle">Stage (ft)</p>
                        <p id="elevSubtitle">Elev (ft)</p>
                    </div>
                </div>
                <div className="sliderDiv" id="sliderForecastDiv" style={{ display: "none" }}>
                    <div className="sliderTitle">
                        <h6 id="mainTitle">Inundation Forecast</h6>
                        <p>Forecasted River Stage (ft)</p>
                        <p id="forecastCondition"></p>

                    </div>
                </div>
            </div>
        )

    }

}
export default MapLayer;


// WEBPACK FOOTER //
// ./src/components/Map2/index.js